type TenantSource = {
  tenantName?: string;
  tenantGuid?: string;
};

export const resolvePersistedTenantId = (authenticatedUser: TenantSource | null | undefined, fallbackTenantId = "") => {
  const authenticatedTenantName = String(authenticatedUser?.tenantName || "").trim();

  if (authenticatedTenantName) {
    return authenticatedTenantName;
  }

  return String(fallbackTenantId || "").trim();
};
